import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function StrengthChart({ refreshKey }) {
    const [data, setData] = useState([]);
    useEffect(() => {
        api.get("/progress/strength-history?weeks=12").then(r => setData(r.data.series || [])).catch(() => setData([]));
    }, [refreshKey]);

    const empty = data.length === 0;
    return (
        <div className="tactical-card p-6" data-testid="strength-chart">
            <div className="flex items-end justify-between">
                <div>
                    <div className="label-eyebrow text-accent-red">Strength Progression</div>
                    <h3 className="mt-1 font-display text-2xl font-black uppercase">Weekly tonnage</h3>
                    <p className="mt-1 text-xs text-muted-foreground">Total weight × reps moved per week (last 12 weeks)</p>
                </div>
                <div className="hidden sm:block text-right">
                    <div className="label-eyebrow text-muted-foreground">Sessions logged</div>
                    <div className="font-display text-2xl font-black tabular-nums">{data.reduce((a, b) => a + (b.sessions || 0), 0)}</div>
                </div>
            </div>
            <div className="mt-4 h-56">
                {empty ? (
                    <div className="flex h-full items-center justify-center text-sm text-muted-foreground">Finish your first workout to start the chart.</div>
                ) : (
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={data}>
                            <CartesianGrid stroke="#2a2a2a" strokeDasharray="3 3" />
                            <XAxis dataKey="week" stroke="#a1a1aa" fontSize={10} />
                            <YAxis stroke="#a1a1aa" fontSize={10} />
                            <Tooltip
                                contentStyle={{ background: "#141414", border: "1px solid #2a2a2a", color: "#fff" }}
                                formatter={(v, name) => [Math.round(v).toLocaleString(), name === "tonnage" ? "Tonnage" : name]}
                            />
                            <Bar dataKey="tonnage" fill="#ff3b30" radius={[2, 2, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </div>
        </div>
    );
}
